import React, { useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mantine/core";
import Typography from "@material-ui/core/Typography";
import Editor from "./avatarEditor";
import { AppContext, TOAST } from "../../context";
import { AccountContext } from "../accountContext";
import { uploadPhoto64 } from "../../infrastructure/actions";

const useStyles = makeStyles((theme) => ({
  photo: {},
  pageInfo: {
    fontSize: "0.875rem",
    color: theme.app.secondaryColor,
    marginTop: ".5rem",
  },
  card: {
    border: `1px solid ${theme.app.borderColor}`,
    borderRadius: "4px",
    marginTop: "16px",
  },
  content: {},
  imageContainer: {
    alignItems: "center",
    background: theme.app.background[1],
    display: "flex",
    height: "300px",
    justifyContent: "center",
    width: "300px",
    padding: "8px",
    border: `1px solid ${theme.app.borderColor}`,
    borderRadius: "4px",
    margin: "16px auto",
    "@media(max-width: 576px)": {
      height: "250px",
      width: "250px",
    },
  },
  image: {
    borderRadius: "4px",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  buttonContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    padding: "8px",
    borderTop: `1px solid ${theme.app.borderColorLight}`,
    background: theme.app.background[1],
  },
  changePhotoAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  button: { color: theme.app.labelColor },
}));

const Photo = (props) => {
  const classes = useStyles();
  const [edit, setEdit] = useState(false);
  const accountContext = useContext(AccountContext);
  const { activePerson } = accountContext.state;
  const { dispatch } = useContext(AppContext);
  const { language, config } = useSelector((state) => ({
    language: state.language,
    config: state.infrastructure.config,
  }));
  const rdxDispatch = useDispatch();
  const handlePhoto = (photoFile) => {
    const photoUrl = `${config.apiUrl}/photobase64/${activePerson.id}`;
    rdxDispatch(
      uploadPhoto64(photoUrl, photoFile, null, (response) => {
        if (response.status >= 400) {
          dispatch({
            type: TOAST,
            payload: {
              text: language.Toasts.photoSubmitFailed,
              variant: "error",
            },
          });
          return console.log(response);
        }
        dispatch({
          type: TOAST,
          payload: {
            text: language.Toasts.photoSubmitSuccess,
            variant: "success",
          },
        });
      })
    );
    setTimeout(() => setEdit(false), 500);
  };

  return (
    <div className={classes.photo}>
      <Typography variant="h1">{language.Pages["photo"]}</Typography>
      <Typography className={classes.pageInfo}>
        {language.PageInfo["photo"]}
      </Typography>
      <div className={classes.card}>
        <div className={classes.content}>
          {edit ? (
            <Editor
              activePerson={activePerson}
              savePhoto={(photo) => handlePhoto(photo)}
              language={language}
              close={() => setEdit(false)}
            />
          ) : (
            <>
              <div className={classes.imageContainer}>
                <img
                  src={activePerson.photo}
                  alt="customer"
                  className={classes.image}
                />
              </div>
              <div className={classes.buttonContainer}>
                <div>
                  <Button
                    className={classes.button}
                    onClick={() => window.history.back()}
                    color="dark"
                    variant="subtle"
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className={classes.changePhotoAction}>
                  <Button
                    className={classNames(
                      classes.editButton,
                      "photo__button, primaryButton"
                    )}
                    onClick={() => setEdit(true)}
                    color="primary"
                  >
                    {language.Change_Photo}
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Photo;
